import React from 'react';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost' | 'destructive';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
  children: React.ReactNode;
}
export function Button({
  variant = 'default',
  size = 'default',
  className,
  children,
  ...props
}: ButtonProps) {
  return <button className={cn('inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50', variant === 'default' && 'bg-blue-600 text-white hover:bg-blue-700', variant === 'outline' && 'border border-input bg-background hover:bg-accent hover:text-accent-foreground', variant === 'ghost' && 'hover:bg-accent hover:text-accent-foreground', variant === 'destructive' && 'bg-destructive text-destructive-foreground hover:bg-destructive/90', size === 'default' && 'h-10 px-4 py-2', size === 'sm' && 'h-9 rounded-md px-3 text-sm', size === 'lg' && 'h-11 rounded-md px-8 text-base', className)} {...props} data-id="element-1056">
      {children}
    </button>;
}